import React, { Component } from 'react';
import styled from 'styled-components';
import withConfig from '../../../context/withConfig';

import sectionBorderRadius from './sectionBorderRadius';

import { updateScroll } from '../../MessageHistory';

const StyledImage = styled.img.attrs(props => ({
  src: props.src,
  clickHandler: props.clickHandler
}))`
  width: 100%;
  display: block;
  // This flag is only used for Carousel's in IE11
  // to prevent images from streching
  ${({ zeroFlexShrink }) => zeroFlexShrink && 'flex-shrink: 0;'} ${sectionBorderRadius};
  ${({ enableClickToOpen }) => enableClickToOpen && 'cursor: pointer;'};
`;

class Image extends Component {
  handleOnClick = () => {
    const {
      src,
      config: { enableClickToOpen }
    } = this.props;
    if (enableClickToOpen) {
      window.open(src, '_blank', 'noopener,noreferrer');
    }
  };

  render() {
    const {
      src,
      isStart,
      isEnd,
      zeroFlexShrink = 0,
      clickHandler,
      config: { enableClickToOpen = false }
    } = this.props;

    return (
      <StyledImage
        zeroFlexShrink={zeroFlexShrink}
        src={src}
        isStart={isStart}
        isEnd={isEnd}
        onLoad={updateScroll}
        data-test-type="botImage"
        onClick={clickHandler || this.handleOnClick}
        enableClickToOpen={enableClickToOpen}
      />
    );
  }
}

export default withConfig(Image);



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Image.js